import { useQuery, UseQueryResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";
import { createUrl } from "../../utils/UrlUtils";

interface Query {
  readonly clinicId: number;
}

export function useDentalPointsListQuery(query: Query): UseQueryResult<DentalPointProps[], Error> {
  return useQuery(["member", "dental-points", "choose", query.clinicId], () =>
    httpClient
      .get(createUrl(ApiRoutes.MemberDentalPointsList, { query }))
      .then(({ data }) => data.data),
  );
}
